import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, KeyRound } from 'lucide-react';
import { usePortal } from './PortalApp';
import { apiError, portalApi } from './portalApi';
import { LoginPane } from './PortalLogin';

export default function PortalSetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const { setSession } = usePortal();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError('This link is missing its token — open the link from your email again.'); return; }
    portalApi.get(`/auth/token/${encodeURIComponent(token)}`).then((r) => setInfo(r.data)).catch((e) => setError(apiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setError('Passwords do not match'); return; }
    setBusy(true); setError('');
    try {
      const r = await portalApi.post('/auth/set-password', { token, password: pw });
      setSession(r.data);
      toast.success('Password set — you are signed in');
      navigate('/portal', { replace: true });
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <LoginPane>
      <div className="p-card p-7 sm:p-8 p-rise" data-testid="portal-set-password-card">
        <div className="p-overline mb-1">{info?.purpose === 'reset' ? 'Reset password' : 'Welcome'}</div>
        <h2 className="p-display text-3xl font-extrabold text-slate-900">{info?.purpose === 'reset' ? 'Choose a new password' : 'Set your password'}</h2>
        {info && <p className="text-sm text-slate-500 mt-1">For <b className="text-slate-800">{info.full_name}</b> ({info.email}){info.customer_name ? <> · {info.customer_name}</> : null}</p>}
        {error && !info && <div className="mt-5 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-3" data-testid="portal-token-error">{error}</div>}
        {info && (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <label className="block"><span className="p-overline">New password (8+ characters)</span>
              <input type="password" autoComplete="new-password" className="p-input mt-1" value={pw} onChange={(e) => setPw(e.target.value)} minLength={8} required data-testid="portal-setpw-input" /></label>
            <label className="block"><span className="p-overline">Confirm password</span>
              <input type="password" autoComplete="new-password" className="p-input mt-1" value={pw2} onChange={(e) => setPw2(e.target.value)} minLength={8} required data-testid="portal-setpw-confirm" /></label>
            {error && <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2" data-testid="portal-setpw-error">{error}</div>}
            <button type="submit" className="p-btn p-btn-primary w-full justify-center" disabled={busy} data-testid="portal-setpw-submit">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Save password & sign in
            </button>
          </form>
        )}
        <div className="mt-5 text-sm"><Link to="/portal/login" className="text-blue-700 font-semibold" data-testid="portal-setpw-back">← Back to sign in</Link></div>
      </div>
    </LoginPane>
  );
}
